
import { HddOutlined, CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, ExperimentOutlined, ApiOutlined } from '@ant-design/icons';

import { Col, DatePicker, Form, InputRef, Row, TableColumnsType, Tooltip } from 'antd';
import { Button, Input, Space, Table, Modal, InputNumber, Select, Drawer } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps, TableRowSelection } from 'antd/es/table/interface';
import React, { useRef, useState, useEffect } from 'react';
import style from './Tables.module.scss'
import {
    getAllOrganization, getValidateOrganization, putActiveOrganization, postRegisterOrganization, putUpdateOrganization,
    getOrganizationById, deleteInactiveOrganization, deleteOrganizationById,
    getTypeOrganization
} from '../../../store/organization/thunks';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import moment from 'moment';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateIdentification, validateLetters, validatePhoneEC, validateBirthday, validateNumber, validateDigitLength, validateLettersAndLength, validate150, validateAndLength } from '../../../globals/Inputs/validateInput';
import validateMessages from '../../../globals/Inputs/validateMessages';
import { typesIdentification } from '../../../globals/Parameters/listParameters';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { Organization } from '../../../store/organization/types';
import { openNotification } from '../../../globals/Components/Notification/Notificaction';
import { deleteEmissionsOrganization, getAllEmissionsTable, getEmissionsOrganization, postResgisterEmissionsOrganization } from 'src/store/emissions/thunks';
import { getAllTransformation, GetTransformationById, postRegisterTransformation, putUpdateTransformation } from "src/store/transformationfactors/thunks";
import { EmissionsSource, TypeOrganization } from 'src/store/emissions/types';
import { TransformationSource } from 'src/store/transformationfactors/types';
import { useHistory } from 'react-router-dom';
import { getAllCountry } from 'src/store/catalogue/thunks';
import { Country } from 'src/store/catalogue/types';
import LoadingIndicator from 'src/globals/Components/Loading/LoadingIndicator';
import TLinkAnalytics from './TLinkAnalytics';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';



interface UserTableProps {

    getAllOrganization?: any;
    getValidateOrganization?: any;
    putActiveOrganization?: any;
    postRegisterOrganization?: any;
    putUpdateOrganization?: any;
    getOrganizationById?: any;
    deleteInactiveOrganization?: any;
    getAllEmissionsTable?: any;
    getEmissionsOrganization?: any;
    postResgisterEmissionsOrganization?: any;
    deleteEmissionsOrganization?: any;
    deleteTransformationOrganization?: any;
    getAllTransformation?: any;
    GetTransformationById?: any;
    postRegisterTransformation?: any;
    putUpdateTransformation?: any;
    deleteOrganizationById?: any;
    getAllCountry?: any;
    getTypeOrganization?:any;

}

interface DataType {
    key: string;
    id: string;
    ruc: string;
    name: string;
    economicActivity: string;
    description: string;
    msCatalogueCountryId: string;
    msCatalogueCountryName: string;
    status: string;
    type: string;
    createdAt: string;
    typeOrganizationId:string;
    
}

export interface Organizations {
    key: string;
    id: string;
    ruc: string;
    name: string;
    economicActivity: string;
    description: string;
    msCatalogueCountryId: string;
    msCatalogueCountryName: string;
    status: string;
    createdAt: string;
}


interface DataTypeEmission {
    key: string;
    category_name: string;
    emissionOrganizationId: string;
    id: string;
    categoryId: string;
    name: string;
    type: string;
    flow: string;
    co2: string;
    ch4: string;
    n20: string;
    brand: string;
    series: string;
    unit: string;
    description: string;
    createdAt: string;
    updatedAt: string;
}

interface DataTypeTransformation {
    key: string;
    id: string;
    transformationOrganizationId: string;
    name: string;
    property: string;
    flow: string;
    unit: string;
    fact: number;
    source: string;
    createdAt: string;
    updatedAt: string;
}

type DataIndex = keyof DataType;
type DataIndexEmission = keyof DataTypeEmission;
type RequiredMark = boolean | 'optional';
const TOrganizations: React.FC<UserTableProps> = (props: UserTableProps) => {
    const dateFormat = 'YYYY-MM-DD';
    const [form] = Form.useForm();
    const [formValidate] = Form.useForm();
    const { Option } = Select;
    const [dataTable, setDataTable] = useState([]);
    const history = useHistory();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenForm, setIsModalOpenForm] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isShowModalLink, setIsShowModalLink] = useState(false);
    const [isModalValidateUser, setIsModalValidateUse] = useState(false);
    const [isModalValidateInactiveUser, setIsModalValidateInactiveUser] = useState(false);
    const [typeModal, setTypeModal] = useState(true);
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const [userData, setUserData] = useState<DataType>();
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [isModalEmision, setIsModalEmision] = useState(false);
    const [IsModalTransformation, setIsModalTransformation] = useState(false);
    const [searchValue, setSearchValue] = useState<EmissionsSource>();
    const [searchValueT, setSearchValueT] = useState<TransformationSource>();
    const [isId, setIsId] = useState("");
    const [isIdT, setIsIdTransformation] = useState("");

    const [isCountry, setIsCountry] = useState<Country[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<Country | undefined>();

    const [dataTableEmissions, setDataTableEmissions] = useState([]);
    const [selectDataTableEmissions, setSelectDataTableEmissions] = useState([]);
    const [selectDataTableTypeOrganization, setSelectDataTableTypeOrganization] = useState<TypeOrganization[]>([]);
    
    const [selectDataTableTransformation, setSelectDataTableTransformation] = useState([]);
    const init = async () => {

        
        
        const responseDataOrganization = await props.getAllOrganization();
        setDataTable(responseDataOrganization);

    }
    useEffect(() => {
        init();
    }, []);


    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });
    const text = <span>prompt text</span>;
    const columns: ColumnsType<DataType> = [
        {
            title: '',
            width: 10,
            dataIndex: 'key',
            key: 'key',


        },
        {
            title: '',
            width: 0,
            dataIndex: 'id',
            key: 'id',
            render: () => null,
        },
        {
            title: '',
            width: 0,
            dataIndex: 'msCatalogueCountryId',
            key: 'msCatalogueCountryId',
            render: () => null,
        },
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Nombre',
            width: 60,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL
            ...getColumnSearchProps('name', 'nombre'),
            sorter: (a, b) => {
                const dateA = new Date(a.name);
                const dateB = new Date(b.name);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
        },
        {
            title: 'RUC',
            width: 50,
            dataIndex: 'ruc',
            key: 'ruc',
            //fixed: 'left',
            ...getColumnSearchProps('ruc', 'ruc'),
        },

        {
            title: 'Actividad económica',
            dataIndex: 'economicActivity',
            key: 'economicActivity',
            width: 70,
            ...getColumnSearchProps('economicActivity', 'Actividad'),
            render: (text, record) => (
                <span style={{ fontSize: '12px', lineHeight: '0.1' }}>{text}</span>
            )
        },
    
        //
        {
            title: 'Razón social',
            dataIndex: 'description',
            key: 'description',
            width: 70,
            filters: [
                {
                    text: 'Natural',
                    value: 'NATURAL',
                },
                {
                    text: 'Juridica',
                    value: 'JURIDICA',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.description.indexOf(value) === 0;
                }
                return false;
            },
            sorter: (a, b) => {
                const dateA = new Date(a.description);
                const dateB = new Date(b.description);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },

        },
        {
            title: 'PaÍs',
            dataIndex: 'msCatalogueCountryName',
            key: 'msCatalogueCountryName',
            width: 40,
            ...getColumnSearchProps('msCatalogueCountryName', 'pais'),
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 40,
            filters: [
                {
                    text: 'Activo',
                    value: 'ACTIVO',
                },
                {
                    text: 'Inactivo',
                    value: 'INACTIVO',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.status.indexOf(value) === 0;
                }
                return false;
            },
        },
        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            width: 30,         
        },
        {
            title: 'Creado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 60,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
            ...getColumnSearchProps('createdAt', 'creado'),
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 60,

            render: (record: DataType) =>
                <Space size="middle">
                    <Tooltip placement="topRight" title={validateMessages.establishmentButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => history.push("/establishment/" + record.id)}
                            icon={<HddOutlined />}
                        >

                        </Button>
                    </Tooltip>
                    <Tooltip placement="topRight" title={validateMessages.emissionButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showEmissionModalUpdate(record.id)}
                            icon={<ExperimentOutlined />}
                        >

                        </Button>
                    </Tooltip>
                    <Tooltip placement="topRight" title={"Agregar link Power BI"} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showModalLink(record)}
                            icon={<ApiOutlined />}
                        />
                    </Tooltip>
                    <Tooltip placement="topRight" title={validateMessages.updateButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showModalUpdate(record)}
                            icon={<EditOutlined />}
                        />
                    </Tooltip>

                    {record.status === 'ACTIVO' && (
                        <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                            <Button
                                type="text"
                                className={style["danger-button"]}
                                onClick={() => updateOrganization(record)}
                                icon={<DeleteOutlined />}
                            />
                        </Tooltip>

                    )}
                    <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                        <Button
                            type="text"
                            className={style["eliminate-button"]}
                            onClick={() => handleTypeDeleteButton(record.id)}
                            icon={<CloseCircleOutlined />}
                        />
                    </Tooltip>

                </Space>,
        },

    ];


    const columnsEmissions: ColumnsType<DataTypeEmission> = [
        {

            title: 'Nombre',
            width: 25,
            dataIndex: 'name',
            key: 'name',

        },
        {
            title: 'Tipo',
            width: 20,
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 20,

            render: (record: DataTypeEmission) =>
                <Space size="middle">
                    <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                        <Button
                            type="text"
                            className={style["danger-button"]}
                            onClick={() => deleteEmissionsOrganiations(record.emissionOrganizationId)}
                            icon={<CloseCircleOutlined />}
                        >
                            
                        </Button>
                    </Tooltip>


                </Space>,
        },


    ];
    const columnsTransformation: ColumnsType<DataTypeTransformation> = [
        {

            title: 'Nombre',
            width: 25,
            dataIndex: 'name',
            key: 'name',

        },
        {
            title: 'Propiedad',
            width: 20,
            dataIndex: 'property',
            key: 'property',
        },
        {
            title: 'Acción',
            key: 'operation',
            fixed: 'right',
            width: 20,

            render: (record: DataTypeTransformation) =>
                <Space size="middle">


                </Space>,
        },


    ];

    const handleOk = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleOkForm = () => {
        form.resetFields();
        //setIsModalOpenForm(false);
    };
    const handleCancelForm = () => {
        form.resetFields();
        setIsModalOpenForm(false);
    };
    const handleDeleteOk = async () => {
        setIsModalDeleteOpen(false);
        await props.deleteInactiveOrganization(userData?.id);
        const responseData = await props.getAllOrganization();
        setDataTable(responseData);
    };
    const handleValidateUserOk = async () => {
        setIsModalValidateUse(false);
    };

    const handleValidateInactiveUserOk = async () => {
        const registerUser = {
            id: userData?.id
        };
        await props.putActiveOrganization(registerUser);
        const responseData = await props.getAllOrganization();
        setDataTable(responseData);
        setIsModalValidateInactiveUser(false);
    };
    const handleDeleteCancel = () => {
        setIsModalDeleteOpen(false);
    };
    const handleValidateUserCancel = () => {
        setIsModalValidateUse(false);
    };
    const handleValidateInactiveUserCancel = () => {
        setIsModalValidateInactiveUser(false);
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const showModalCreate = async () => {
        setIsFormValidate(true);
        setIsModalOpen(true);
        setTypeModal(true);
        const responseData = await props.getTypeOrganization();
        setSelectDataTableTypeOrganization(responseData);

    };
    const showModalLink = async (value: DataType) => {
        setUserData(value);
        setIsShowModalLink(true);
    }
    const showModalUpdate = async (value: DataType) => {

        const responseData = await props.getAllCountry();
        setIsCountry(responseData);
        const responseDataType = await props.getTypeOrganization();
        setSelectDataTableTypeOrganization(responseDataType);
        form.setFieldsValue({

            countryId: value.msCatalogueCountryId, id: value.id, ruc: value.ruc, name: value.name, activity: value.economicActivity,
            description: value.description, country: value.msCatalogueCountryName,
            typeorg:value.typeOrganizationId
        });


        setIsModalOpenForm(true);
        setIsFormValidate(false);
        setTypeModal(false);
    };
    const showEmissionModalUpdate = async (value: string) => {
        setIsModalEmision(true);
        setIsId(value);
        const responseDataOrganization = await props.getEmissionsOrganization(value);
        setDataTableEmissions(responseDataOrganization);
        const responseDataOrganizationTable = await props.getAllEmissionsTable(value);
        setSelectDataTableEmissions(responseDataOrganizationTable);

    };


    const showEmissionModalFalse = async () => {
        setIsModalEmision(false);
    };
    const showTransformationModalFalse = async () => {
        setIsModalTransformation(false);
    };
    const deleteEmissionsOrganiations = async (value: string) => {
        //setIsModalEmision(false);
        await props.deleteEmissionsOrganization(value)
        const responseDataOrganization = await props.getEmissionsOrganization(isId);
        setDataTableEmissions(responseDataOrganization);
    };



    const updateOrganization = async (value: DataType) => {
        setUserData(value);
        //form.setFieldsValue({ id: value.id, empresa: value.msBusinessBusinessName, nombre: value.name, dni: value.dni, telefono: value.phone, email: value.email,rol:value.rol });

        setIsModalDeleteOpen(true);

    };
    const onFinish = async (values: any) => {
        
        const registerUser = {
            id: values.id,
            ruc: values.ruc,
            name: values.name,
            economicActivity: values.activity,
            description: values.description == undefined ? ' ' : values.description,
            countryId: selectedCountry?.id == undefined ? values.countryId : selectedCountry?.id,
            country: selectedCountry?.name == undefined ? values.country : selectedCountry?.name,
            typeOrganizationId:values.typeorg,
            link: values.link
        };
        handleCancel();
        if (typeModal) {
            await props.postRegisterOrganization(registerUser);
        } else {
            await props.putUpdateOrganization(registerUser);
        }
        const responseData = await props.getAllOrganization();
        setDataTable(responseData);
        setIsModalOpenForm(false);
        form.resetFields();
        handleOkForm();


    };
    const onFinishValidate = async (values: any) => {

        const responseData = await props.getValidateOrganization(values.ruc);
        if (responseData != null && responseData.status.trim() == "ACTIVE") {
            const dataUser: DataType = {
                key: "1",
                id: responseData.id,
                ruc: values.ruc,
                name: responseData.name,
                economicActivity: "",
                description: "",
                msCatalogueCountryId: "",
                msCatalogueCountryName: "",
                type:"",
                status: "",
                createdAt: "",
                typeOrganizationId:""
            };
            setUserData(dataUser);
            setIsModalOpen(false);
            setIsModalValidateUse(true);

        } else if (responseData != null && responseData.status.trim() == "INACTIVE") {
            const dataUser: DataType = {
                key: "1",
                id: responseData.id,
                ruc: responseData.ruc,
                name: responseData.name,
                economicActivity: "",
                description: "",
                msCatalogueCountryId: "",
                type:"",
                msCatalogueCountryName: "",
                status: "",
                createdAt: "",
                typeOrganizationId:""
            };
            setUserData(dataUser);
            setIsModalOpen(false);
            setIsModalValidateInactiveUser(true);

        } else {
            form.setFieldsValue({
                ruc: values.ruc,
            });

            const responseData = await props.getAllCountry();
            setIsCountry(responseData);
            setIsModalOpenForm(true);
            setIsModalOpen(false);
            setIsFormValidate(false);

        }
        formValidate.resetFields();


    };

    const onRegisterEmissions = async (values: any) => {
        const register = {
            emissionSourcesId: values.emissions,
            organizationId: isId
        }
        await props.postResgisterEmissionsOrganization(register);
        const responseDataOrganization = await props.getEmissionsOrganization(isId);
        setDataTableEmissions(responseDataOrganization);
    }
    const initialValues = {
        ruc: 'valor predeterminado aquí', // Establece el valor predeterminado para el campo 'ruc'
    };



    const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false);
    const [isIdData, setIdData] = useState<String>("");

    const handleDeleteMethodOk = async () => {
        const responseData = await props.deleteOrganizationById(isIdData);
        if (responseData != undefined) {
            const responseDataEstablishment = await props.getAllOrganization();
            setDataTable(responseDataEstablishment);
        }

        setIsModalDeleteMethodOpen(false);
    };
    const handleDeleteMethodCancel = () => {
        setIsModalDeleteMethodOpen(false);
    };
    const handleTypeDeleteButton = async (value: String) => {
        setIdData(value);
        setIsModalDeleteMethodOpen(true);

    }

    const handleCountryChange = (selectedId: string) => {
        const selected = isCountry.find((country) => country.id === selectedId);
        setSelectedCountry(selected);
    };

    return (
        <>
            <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={showModalCreate}
            >
                Crear organización
            </Button>
            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1500 }} />
            <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
                width={350} footer={null}       >
                <AdminHeader className={style["title-modal"]}>
                    {"Validar organización"}
                </AdminHeader>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinishValidate}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item label="RUC" name="ruc" rules={[
                        { required: true, message: validateMessages.emptyField }
                    ]}>
                        <Input placeholder="Ingresar RUC" />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["create-button-user"]} type="primary" htmlType="submit">
                            Validar
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Drawer title={typeModal ? "Crear una nueva organización" : "Actualizar organización"} open={isModalOpenForm} onClose={handleCancelForm} width={350} footer={null}>
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item style={{ display: 'none' }} label="" name="id" >
                        <Input />
                    </Form.Item>
                    <Form.Item style={{ display: 'none' }} label="" name="countryId" >
                        <Input />
                    </Form.Item>

                    <Form.Item label="RUC" name="ruc" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateDigitLength(value) },]}>
                        <Input disabled={true} placeholder="Ingresar RUC" />
                    </Form.Item>
                    <Form.Item label="Nombre" name="name" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validateAndLength(value) },]}>
                        <Input placeholder="Ingresar nombre" />
                    </Form.Item>

                    <Form.Item name="activity" label="Actividad económica" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) }]}>
                        <Input placeholder="Ingresar actividad económica" />
                    </Form.Item>
                    <Form.Item name="description" label="Razón social" >
                        <Input placeholder="Ingresar razón social" />
                    </Form.Item>
                    <Form.Item label="País" name="country" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            style={{ width: "100%" }}
                            onChange={handleCountryChange} // Establece el ID del país seleccionado
                            value={selectedCountry?.id} // El valor debe ser el ID del país seleccionado
                            placeholder="Escoge un país"
                        >
                            {isCountry.map((country: Country) => (
                                <Option key={country.id} value={country.id}>
                                    {country.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    
                    <Form.Item label="Tipo" name="typeorg" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: EmissionsSource) => setSearchValue(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga el tipo de organización"
                        >
                            {selectDataTableTypeOrganization.map((type: TypeOrganization) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name="link" label="Url Power BI" >
                        <Input placeholder="Ingresar url" />
                    </Form.Item>
                    <Form.Item>
                        <Button className={style["create-button-user"]} type="primary" htmlType="submit">
                            {typeModal ? "Agregar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
            <Modal open={isModalDeleteOpen} onOk={handleDeleteOk} onCancel={handleDeleteCancel}>
                <h3>¿Esta seguro de inactivar a la organización {userData?.name} con cédula {userData?.ruc}? </h3>
            </Modal>
            <Modal open={isModalValidateUser} onOk={handleValidateUserOk} onCancel={handleValidateUserCancel}>
                <h3>La organización {userData?.name} con ruc {userData?.ruc} ya se encuentra activo </h3>
            </Modal>
            <Modal open={isModalValidateInactiveUser} onOk={handleValidateInactiveUserOk} onCancel={handleValidateInactiveUserCancel}>
                <h3>La organización {userData?.name} con ruc {userData?.ruc} se encuentra inactivo. <br /> ¿Deseas activarlo? </h3>
            </Modal>

            <Drawer open={isModalEmision} width={950} footer={null} /*onOk={showEmissionModalFalse}*/ onClose={showEmissionModalFalse}>
                <h3>Seleccionar fuentes de emisión</h3>
                <Form
                    form={form}
                    layout="inline"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegisterEmissions}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item className={style["select-fe"]} name="emissions" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select

                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: EmissionsSource) => setSearchValue(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga la fuente de emisión"
                        >
                            {selectDataTableEmissions.map((type: EmissionsSource) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name + "-" + type.flow}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>


                    <Form.Item  >
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                        >
                            Guardar selección
                        </Button>
                    </Form.Item>
                </Form>
                <Table size="small" columns={columnsEmissions} dataSource={dataTableEmissions} scroll={{ x: 500 }} />
                <LoadingIndicator />
            </Drawer>
            <Modal open={isModalDeleteMethodOpen} onOk={handleDeleteMethodOk} onCancel={handleDeleteMethodCancel}>
                <h3>¿Esta seguro que desea eliminar la Organización? </h3>
            </Modal>
            <TLinkAnalytics showModal={isShowModalLink} organizationId={userData?.id} onClose={() => setIsShowModalLink(false)}/>

        </>
    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getAllOrganization, getValidateOrganization, putActiveOrganization, postRegisterOrganization, putUpdateOrganization,
    getOrganizationById, deleteInactiveOrganization, getAllEmissionsTable, getEmissionsOrganization,
    postResgisterEmissionsOrganization, deleteOrganizationById, deleteEmissionsOrganization, getAllTransformation, GetTransformationById, postRegisterTransformation, putUpdateTransformation,
    getAllCountry,getTypeOrganization
})(TOrganizations);


